function Se(r, e) {
  globalThis.vonage || (globalThis.vonage = {}), globalThis.vonage.workerizer || (globalThis.vonage.workerizer = {});
  let t = globalThis.vonage.workerizer;
  return t[r] || (t[r] = e), t[r];
}
const W = Se(
  "globals",
  {}
);
var d = /* @__PURE__ */ ((r) => (r.INIT = "INIT", r.FORWARD = "FORWARD", r.TERMINATE = "TERMINATE", r.GLOBALS_SYNC = "GLOBALS_SYNC", r.EVENT = "EVENT", r))(d || {});
function Ve(r) {
  var e;
  return [
    typeof ImageBitmap < "u" ? ImageBitmap : void 0,
    typeof ReadableStream < "u" ? ReadableStream : void 0,
    typeof WritableStream < "u" ? WritableStream : void 0,
    typeof MediaStreamTrack < "u" ? MediaStreamTrack : void 0,
    (e = globalThis.MediaStreamTrackHandle) != null ? e : void 0
  ].some((s) => s && r instanceof s);
}
let tt = 0;
function Z(r, e, t, s, i) {
  const o = tt++;
  return r.postMessage(
    {
      id: o,
      type: e,
      functionName: t,
      args: s
    },
    s.filter((a) => Ve(a))
  ), new Promise((a) => {
    i?.set(o, a);
  });
}
function C(r, e) {
  const { id: t, type: s } = r, i = Array.isArray(e) ? e : [e];
  postMessage(
    {
      id: t,
      type: s,
      result: e
    },
    i.filter((o) => Ve(o))
  );
}
const K = Se("workerized", {});
function ve() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
async function rt() {
  if (ve())
    C({ type: d.GLOBALS_SYNC }, W);
  else {
    const r = [];
    for (const e in K) {
      const { worker: t, resolvers: s } = K[e].workerContext;
      t && r.push(
        Z(
          t,
          d.GLOBALS_SYNC,
          "",
          [W],
          s
        )
      );
    }
    await Promise.all(r);
  }
}
function U(r, e) {
  if (Array.isArray(e))
    e.splice(0, e.length);
  else if (typeof e == "object")
    for (const t in e)
      delete e[t];
  for (const t in r)
    Array.isArray(r[t]) ? (e[t] = [], U(r[t], e[t])) : typeof r[t] == "object" ? (e[t] = {}, U(r[t], e[t])) : e[t] = r[t];
}
async function st(r, e, t, s) {
  const i = new e();
  if (i.addEventListener(
    "message",
    async ({ data: n }) => {
      var a, l, c, u, Me, Ie, Pe;
      switch (n.type) {
        case d.GLOBALS_SYNC:
          n.id ? ((l = t.get((a = n.id) != null ? a : -1)) == null || l(n.result), t.delete((c = n.id) != null ? c : -1)) : (U((u = n.result) != null ? u : {}, W), await rt());
          break;
        case d.EVENT:
          const { result: et } = n, B = et;
          if (B?.name == null)
            throw "Missing event name";
          s(B.name, B.data);
          break;
        default:
          (Ie = t.get((Me = n.id) != null ? Me : -1)) == null || Ie(n.result), t.delete((Pe = n.id) != null ? Pe : -1);
      }
    }
  ), !await Z(
    i,
    d.INIT,
    "",
    [r.workerId, W],
    t
  ))
    throw "Failed to instantiate workerized class";
  return i;
}
const b = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ Symbol("anyProducer"), $e = Promise.resolve(), ee = /* @__PURE__ */ Symbol("listenerAdded"), te = /* @__PURE__ */ Symbol("listenerRemoved");
let re = !1, ge = !1;
function A(r) {
  if (typeof r != "string" && typeof r != "symbol" && typeof r != "number")
    throw new TypeError("`eventName` must be a string, symbol, or number");
}
function H(r) {
  if (typeof r != "function")
    throw new TypeError("listener must be a function");
}
function k(r, e) {
  const t = T.get(r);
  if (t.has(e))
    return t.get(e);
}
function F(r, e) {
  const t = typeof e == "string" || typeof e == "symbol" || typeof e == "number" ? e : N, s = h.get(r);
  if (s.has(t))
    return s.get(t);
}
function it(r, e, t) {
  const s = h.get(r);
  if (s.has(e))
    for (const i of s.get(e))
      i.enqueue(t);
  if (s.has(N)) {
    const i = Promise.all([e, t]);
    for (const o of s.get(N))
      o.enqueue(i);
  }
}
function Re(r, e) {
  e = Array.isArray(e) ? e : [e];
  let t = !1, s = () => {
  }, i = [];
  const o = {
    enqueue(n) {
      i.push(n), s();
    },
    finish() {
      t = !0, s();
    }
  };
  for (const n of e) {
    let a = F(r, n);
    a || (a = /* @__PURE__ */ new Set(), h.get(r).set(n, a)), a.add(o);
  }
  return {
    async next() {
      return i ? i.length === 0 ? t ? (i = void 0, this.next()) : (await new Promise((n) => {
        s = n;
      }), this.next()) : {
        done: !1,
        value: await i.shift()
      } : { done: !0 };
    },
    async return(n) {
      i = void 0;
      for (const a of e) {
        const l = F(r, a);
        l && (l.delete(o), l.size === 0 && h.get(r).delete(a));
      }
      return s(), arguments.length > 0 ? { done: !0, value: await n } : { done: !0 };
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function Oe(r) {
  if (r === void 0)
    return Le;
  if (!Array.isArray(r))
    throw new TypeError("`methodNames` must be an array of strings");
  for (const e of r)
    if (!Le.includes(e))
      throw typeof e != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${e} is not Emittery method`);
  return r;
}
const R = (r) => r === ee || r === te;
function V(r, e, t) {
  if (R(e))
    try {
      re = !0, r.emit(e, t);
    } finally {
      re = !1;
    }
}
let pe = class Ee {
  static mixin(e, t) {
    return t = Oe(t), (s) => {
      if (typeof s != "function")
        throw new TypeError("`target` must be function");
      for (const n of t)
        if (s.prototype[n] !== void 0)
          throw new Error(`The property \`${n}\` already exists on \`target\``);
      function i() {
        return Object.defineProperty(this, e, {
          enumerable: !1,
          value: new Ee()
        }), this[e];
      }
      Object.defineProperty(s.prototype, e, {
        enumerable: !1,
        get: i
      });
      const o = (n) => function(...a) {
        return this[e][n](...a);
      };
      for (const n of t)
        Object.defineProperty(s.prototype, n, {
          enumerable: !1,
          value: o(n)
        });
      return s;
    };
  }
  static get isDebugEnabled() {
    var e, t;
    if (typeof ((e = globalThis.process) == null ? void 0 : e.env) != "object")
      return ge;
    const { env: s } = (t = globalThis.process) != null ? t : { env: {} };
    return s.DEBUG === "emittery" || s.DEBUG === "*" || ge;
  }
  static set isDebugEnabled(e) {
    ge = e;
  }
  constructor(e = {}) {
    var t;
    b.set(this, /* @__PURE__ */ new Set()), T.set(this, /* @__PURE__ */ new Map()), h.set(this, /* @__PURE__ */ new Map()), h.get(this).set(N, /* @__PURE__ */ new Set()), this.debug = (t = e.debug) != null ? t : {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (s, i, o, n) => {
      try {
        n = JSON.stringify(n);
      } catch {
        n = `Object with the following keys failed to stringify: ${Object.keys(n).join(",")}`;
      }
      (typeof o == "symbol" || typeof o == "number") && (o = o.toString());
      const a = /* @__PURE__ */ new Date(), l = `${a.getHours()}:${a.getMinutes()}:${a.getSeconds()}.${a.getMilliseconds()}`;
      console.log(`[${l}][emittery:${s}][${i}] Event Name: ${o}
	data: ${n}`);
    });
  }
  logIfDebugEnabled(e, t, s) {
    (Ee.isDebugEnabled || this.debug.enabled) && this.debug.logger(e, this.debug.name, t, s);
  }
  on(e, t) {
    H(t), e = Array.isArray(e) ? e : [e];
    for (const s of e) {
      A(s);
      let i = k(this, s);
      i || (i = /* @__PURE__ */ new Set(), T.get(this).set(s, i)), i.add(t), this.logIfDebugEnabled("subscribe", s, void 0), R(s) || V(this, ee, { eventName: s, listener: t });
    }
    return this.off.bind(this, e, t);
  }
  off(e, t) {
    H(t), e = Array.isArray(e) ? e : [e];
    for (const s of e) {
      A(s);
      const i = k(this, s);
      i && (i.delete(t), i.size === 0 && T.get(this).delete(s)), this.logIfDebugEnabled("unsubscribe", s, void 0), R(s) || V(this, te, { eventName: s, listener: t });
    }
  }
  once(e) {
    let t;
    const s = new Promise((i) => {
      t = this.on(e, (o) => {
        t(), i(o);
      });
    });
    return s.off = t, s;
  }
  events(e) {
    e = Array.isArray(e) ? e : [e];
    for (const t of e)
      A(t);
    return Re(this, e);
  }
  async emit(e, t) {
    var s;
    if (A(e), R(e) && !re)
      throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
    this.logIfDebugEnabled("emit", e, t), it(this, e, t);
    const i = (s = k(this, e)) != null ? s : /* @__PURE__ */ new Set(), o = b.get(this), n = [...i], a = R(e) ? [] : [...o];
    await $e, await Promise.all([
      ...n.map(async (l) => {
        if (i.has(l))
          return l(t);
      }),
      ...a.map(async (l) => {
        if (o.has(l))
          return l(e, t);
      })
    ]);
  }
  async emitSerial(e, t) {
    var s;
    if (A(e), R(e) && !re)
      throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
    this.logIfDebugEnabled("emitSerial", e, t);
    const i = (s = k(this, e)) != null ? s : /* @__PURE__ */ new Set(), o = b.get(this), n = [...i], a = [...o];
    await $e;
    for (const l of n)
      i.has(l) && await l(t);
    for (const l of a)
      o.has(l) && await l(e, t);
  }
  onAny(e) {
    return H(e), this.logIfDebugEnabled("subscribeAny", void 0, void 0), b.get(this).add(e), V(this, ee, { listener: e }), this.offAny.bind(this, e);
  }
  anyEvent() {
    return Re(this);
  }
  offAny(e) {
    H(e), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), V(this, te, { listener: e }), b.get(this).delete(e);
  }
  clearListeners(e) {
    e = Array.isArray(e) ? e : [e];
    for (const t of e)
      if (this.logIfDebugEnabled("clear", t, void 0), typeof t == "string" || typeof t == "symbol" || typeof t == "number") {
        const s = k(this, t);
        s && s.clear();
        const i = F(this, t);
        if (i) {
          for (const o of i)
            o.finish();
          i.clear();
        }
      } else {
        b.get(this).clear();
        for (const [s, i] of T.get(this).entries())
          i.clear(), T.get(this).delete(s);
        for (const [s, i] of h.get(this).entries()) {
          for (const o of i)
            o.finish();
          i.clear(), h.get(this).delete(s);
        }
      }
  }
  listenerCount(e) {
    var t, s, i, o, n, a;
    e = Array.isArray(e) ? e : [e];
    let l = 0;
    for (const c of e) {
      if (typeof c == "string") {
        l += b.get(this).size + ((s = (t = k(this, c)) == null ? void 0 : t.size) != null ? s : 0) + ((o = (i = F(this, c)) == null ? void 0 : i.size) != null ? o : 0) + ((a = (n = F(this)) == null ? void 0 : n.size) != null ? a : 0);
        continue;
      }
      typeof c < "u" && A(c), l += b.get(this).size;
      for (const u of T.get(this).values())
        l += u.size;
      for (const u of h.get(this).values())
        l += u.size;
    }
    return l;
  }
  bindMethods(e, t) {
    if (typeof e != "object" || e === null)
      throw new TypeError("`target` must be an object");
    t = Oe(t);
    for (const s of t) {
      if (e[s] !== void 0)
        throw new Error(`The property \`${s}\` already exists on \`target\``);
      Object.defineProperty(e, s, {
        enumerable: !1,
        value: this[s].bind(this)
      });
    }
  }
};
const Le = Object.getOwnPropertyNames(pe.prototype).filter((r) => r !== "constructor");
Object.defineProperty(pe, "listenerAdded", {
  value: ee,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
Object.defineProperty(pe, "listenerRemoved", {
  value: te,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
function nt(r) {
  return r.onAny && r.emit;
}
function ot(r) {
  return r.prototype.onAny && r.prototype.emit;
}
let at = 0;
async function lt(r, e, t) {
  const i = ot(r) ? new pe() : {}, o = at++;
  return Object.getOwnPropertyNames(r.prototype).forEach(
    (n) => {
      i[n] = (...a) => Z(e, d.FORWARD, n, a, t);
    }
  ), i.terminate = async (...n) => {
    const a = await Z(
      e,
      d.TERMINATE,
      "",
      n,
      t
    );
    return delete K[o], e.terminate(), i.workerContext.worker = void 0, a;
  }, i.workerContext = {
    id: o,
    worker: e,
    resolvers: t
  }, K[o] = i, i;
}
async function ct(r, e) {
  const t = /* @__PURE__ */ new Map();
  let s;
  const i = await st(
    r,
    e,
    t,
    (o, n) => {
      s?.emit && s?.emit(o, n);
    }
  );
  return s = await lt(
    r,
    i,
    t
  ), s;
}
async function ft(r, e) {
  const { functionName: t, args: s } = r;
  if (!e.instance)
    throw "instance not initialized";
  if (!t)
    throw "missing function name to call";
  if (!e.instance[t])
    throw `undefined function [${t}] in class ${e.instance.constructor.workerId}`;
  C(r, await e.instance[t](...s ?? []));
}
const qe = Se("registeredWorkers", {});
function ut(r, e) {
  e.workerId = r, ve() && (qe[e.workerId] = e);
}
function dt(r, e) {
  if (!r.args)
    throw "Missing className while initializing worker";
  const [t, s] = r.args, i = qe[t];
  if (i)
    e.instance = new i(r.args.slice(1));
  else
    throw `unknown worker class ${t}`;
  U(s, W), nt(e.instance) && e.instance.onAny((o, n) => {
    C(
      {
        type: d.EVENT
      },
      { name: o, data: n }
    );
  }), C(r, typeof e.instance !== void 0);
}
async function ht(r, e) {
  const { args: t } = r;
  if (!e.instance)
    throw "instance not initialized";
  let s;
  e.instance.terminate && (s = await e.instance.terminate(...t ?? [])), C(r, s);
}
function pt(r) {
  if (!r.args)
    throw "Missing globals while syncing";
  U(r.args[0], W), C(r, {});
}
function gt() {
  const r = {};
  onmessage = async (e) => {
    const t = e.data;
    switch (t.type) {
      case d.INIT:
        dt(t, r);
        break;
      case d.FORWARD:
        ft(t, r);
        break;
      case d.TERMINATE:
        ht(t, r);
        break;
      case d.GLOBALS_SYNC:
        pt(t);
        break;
    }
  };
}
ve() && gt();
const Ye = '(function(){"use strict";function v(i,e){globalThis.vonage||(globalThis.vonage={}),globalThis.vonage.workerizer||(globalThis.vonage.workerizer={});let t=globalThis.vonage.workerizer;return t[i]||(t[i]=e),t[i]}const W=v("globals",{});var d=(i=>(i.INIT="INIT",i.FORWARD="FORWARD",i.TERMINATE="TERMINATE",i.GLOBALS_SYNC="GLOBALS_SYNC",i.EVENT="EVENT",i))(d||{});function D(i){var e;return[typeof ImageBitmap<"u"?ImageBitmap:void 0,typeof ReadableStream<"u"?ReadableStream:void 0,typeof WritableStream<"u"?WritableStream:void 0,typeof MediaStreamTrack<"u"?MediaStreamTrack:void 0,(e=globalThis.MediaStreamTrackHandle)!=null?e:void 0].some(r=>r&&i instanceof r)}function w(i,e){const{id:t,type:r}=i,s=Array.isArray(e)?e:[e];postMessage({id:t,type:r,result:e},s.filter(n=>D(n)))}v("workerized",{});function P(){return typeof WorkerGlobalScope<"u"&&self instanceof WorkerGlobalScope}function A(i,e){if(Array.isArray(e))e.splice(0,e.length);else if(typeof e=="object")for(const t in e)delete e[t];for(const t in i)Array.isArray(i[t])?(e[t]=[],A(i[t],e[t])):typeof i[t]=="object"?(e[t]={},A(i[t],e[t])):e[t]=i[t]}const c=new WeakMap,u=new WeakMap,f=new WeakMap,T=Symbol("anyProducer"),R=Promise.resolve(),k=Symbol("listenerAdded"),S=Symbol("listenerRemoved");let I=!1,O=!1;function b(i){if(typeof i!="string"&&typeof i!="symbol"&&typeof i!="number")throw new TypeError("`eventName` must be a string, symbol, or number")}function M(i){if(typeof i!="function")throw new TypeError("listener must be a function")}function h(i,e){const t=u.get(i);if(t.has(e))return t.get(e)}function E(i,e){const t=typeof e=="string"||typeof e=="symbol"||typeof e=="number"?e:T,r=f.get(i);if(r.has(t))return r.get(t)}function B(i,e,t){const r=f.get(i);if(r.has(e))for(const s of r.get(e))s.enqueue(t);if(r.has(T)){const s=Promise.all([e,t]);for(const n of r.get(T))n.enqueue(s)}}function $(i,e){e=Array.isArray(e)?e:[e];let t=!1,r=()=>{},s=[];const n={enqueue(o){s.push(o),r()},finish(){t=!0,r()}};for(const o of e){let l=E(i,o);l||(l=new Set,f.get(i).set(o,l)),l.add(n)}return{async next(){return s?s.length===0?t?(s=void 0,this.next()):(await new Promise(o=>{r=o}),this.next()):{done:!1,value:await s.shift()}:{done:!0}},async return(o){s=void 0;for(const l of e){const a=E(i,l);a&&(a.delete(n),a.size===0&&f.get(i).delete(l))}return r(),arguments.length>0?{done:!0,value:await o}:{done:!0}},[Symbol.asyncIterator](){return this}}}function j(i){if(i===void 0)return L;if(!Array.isArray(i))throw new TypeError("`methodNames` must be an array of strings");for(const e of i)if(!L.includes(e))throw typeof e!="string"?new TypeError("`methodNames` element must be a string"):new Error(`${e} is not Emittery method`);return i}const g=i=>i===k||i===S;function m(i,e,t){if(g(e))try{I=!0,i.emit(e,t)}finally{I=!1}}class y{static mixin(e,t){return t=j(t),r=>{if(typeof r!="function")throw new TypeError("`target` must be function");for(const o of t)if(r.prototype[o]!==void 0)throw new Error(`The property \\`${o}\\` already exists on \\`target\\``);function s(){return Object.defineProperty(this,e,{enumerable:!1,value:new y}),this[e]}Object.defineProperty(r.prototype,e,{enumerable:!1,get:s});const n=o=>function(...l){return this[e][o](...l)};for(const o of t)Object.defineProperty(r.prototype,o,{enumerable:!1,value:n(o)});return r}}static get isDebugEnabled(){var e,t;if(typeof((e=globalThis.process)==null?void 0:e.env)!="object")return O;const{env:r}=(t=globalThis.process)!=null?t:{env:{}};return r.DEBUG==="emittery"||r.DEBUG==="*"||O}static set isDebugEnabled(e){O=e}constructor(e={}){var t;c.set(this,new Set),u.set(this,new Map),f.set(this,new Map),f.get(this).set(T,new Set),this.debug=(t=e.debug)!=null?t:{},this.debug.enabled===void 0&&(this.debug.enabled=!1),this.debug.logger||(this.debug.logger=(r,s,n,o)=>{try{o=JSON.stringify(o)}catch{o=`Object with the following keys failed to stringify: ${Object.keys(o).join(",")}`}(typeof n=="symbol"||typeof n=="number")&&(n=n.toString());const l=new Date,a=`${l.getHours()}:${l.getMinutes()}:${l.getSeconds()}.${l.getMilliseconds()}`;console.log(`[${a}][emittery:${r}][${s}] Event Name: ${n}\n	data: ${o}`)})}logIfDebugEnabled(e,t,r){(y.isDebugEnabled||this.debug.enabled)&&this.debug.logger(e,this.debug.name,t,r)}on(e,t){M(t),e=Array.isArray(e)?e:[e];for(const r of e){b(r);let s=h(this,r);s||(s=new Set,u.get(this).set(r,s)),s.add(t),this.logIfDebugEnabled("subscribe",r,void 0),g(r)||m(this,k,{eventName:r,listener:t})}return this.off.bind(this,e,t)}off(e,t){M(t),e=Array.isArray(e)?e:[e];for(const r of e){b(r);const s=h(this,r);s&&(s.delete(t),s.size===0&&u.get(this).delete(r)),this.logIfDebugEnabled("unsubscribe",r,void 0),g(r)||m(this,S,{eventName:r,listener:t})}}once(e){let t;const r=new Promise(s=>{t=this.on(e,n=>{t(),s(n)})});return r.off=t,r}events(e){e=Array.isArray(e)?e:[e];for(const t of e)b(t);return $(this,e)}async emit(e,t){var r;if(b(e),g(e)&&!I)throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");this.logIfDebugEnabled("emit",e,t),B(this,e,t);const s=(r=h(this,e))!=null?r:new Set,n=c.get(this),o=[...s],l=g(e)?[]:[...n];await R,await Promise.all([...o.map(async a=>{if(s.has(a))return a(t)}),...l.map(async a=>{if(n.has(a))return a(e,t)})])}async emitSerial(e,t){var r;if(b(e),g(e)&&!I)throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");this.logIfDebugEnabled("emitSerial",e,t);const s=(r=h(this,e))!=null?r:new Set,n=c.get(this),o=[...s],l=[...n];await R;for(const a of o)s.has(a)&&await a(t);for(const a of l)n.has(a)&&await a(e,t)}onAny(e){return M(e),this.logIfDebugEnabled("subscribeAny",void 0,void 0),c.get(this).add(e),m(this,k,{listener:e}),this.offAny.bind(this,e)}anyEvent(){return $(this)}offAny(e){M(e),this.logIfDebugEnabled("unsubscribeAny",void 0,void 0),m(this,S,{listener:e}),c.get(this).delete(e)}clearListeners(e){e=Array.isArray(e)?e:[e];for(const t of e)if(this.logIfDebugEnabled("clear",t,void 0),typeof t=="string"||typeof t=="symbol"||typeof t=="number"){const r=h(this,t);r&&r.clear();const s=E(this,t);if(s){for(const n of s)n.finish();s.clear()}}else{c.get(this).clear();for(const[r,s]of u.get(this).entries())s.clear(),u.get(this).delete(r);for(const[r,s]of f.get(this).entries()){for(const n of s)n.finish();s.clear(),f.get(this).delete(r)}}}listenerCount(e){var t,r,s,n,o,l;e=Array.isArray(e)?e:[e];let a=0;for(const p of e){if(typeof p=="string"){a+=c.get(this).size+((r=(t=h(this,p))==null?void 0:t.size)!=null?r:0)+((n=(s=E(this,p))==null?void 0:s.size)!=null?n:0)+((l=(o=E(this))==null?void 0:o.size)!=null?l:0);continue}typeof p<"u"&&b(p),a+=c.get(this).size;for(const z of u.get(this).values())a+=z.size;for(const z of f.get(this).values())a+=z.size}return a}bindMethods(e,t){if(typeof e!="object"||e===null)throw new TypeError("`target` must be an object");t=j(t);for(const r of t){if(e[r]!==void 0)throw new Error(`The property \\`${r}\\` already exists on \\`target\\``);Object.defineProperty(e,r,{enumerable:!1,value:this[r].bind(this)})}}}const L=Object.getOwnPropertyNames(y.prototype).filter(i=>i!=="constructor");Object.defineProperty(y,"listenerAdded",{value:k,writable:!1,enumerable:!0,configurable:!1}),Object.defineProperty(y,"listenerRemoved",{value:S,writable:!1,enumerable:!0,configurable:!1});function C(i){return i.onAny&&i.emit}async function V(i,e){const{functionName:t,args:r}=i;if(!e.instance)throw"instance not initialized";if(!t)throw"missing function name to call";if(!e.instance[t])throw`undefined function [${t}] in class ${e.instance.constructor.workerId}`;w(i,await e.instance[t](...r??[]))}const _=v("registeredWorkers",{});function q(i,e){e.workerId=i,P()&&(_[e.workerId]=e)}function F(i,e){if(!i.args)throw"Missing className while initializing worker";const[t,r]=i.args,s=_[t];if(s)e.instance=new s(i.args.slice(1));else throw`unknown worker class ${t}`;A(r,W),C(e.instance)&&e.instance.onAny((n,o)=>{w({type:d.EVENT},{name:n,data:o})}),w(i,typeof e.instance!==void 0)}async function Y(i,e){const{args:t}=i;if(!e.instance)throw"instance not initialized";let r;e.instance.terminate&&(r=await e.instance.terminate(...t??[])),w(i,r)}function H(i){if(!i.args)throw"Missing globals while syncing";A(i.args[0],W),w(i,{})}function G(){const i={};onmessage=async e=>{const t=e.data;switch(t.type){case d.INIT:F(t,i);break;case d.FORWARD:V(t,i);break;case d.TERMINATE:Y(t,i);break;case d.GLOBALS_SYNC:H(t);break}}}P()&&G();class U{check(){return typeof globalThis.MediaStreamTrackProcessor<"u"&&typeof globalThis.VideoTrackGenerator<"u"}}q("IsSupportedWorkerized",U),G()})();\n', We = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", Ye], { type: "text/javascript;charset=utf-8" });
function yt(r) {
  let e;
  try {
    if (e = We && (self.URL || self.webkitURL).createObjectURL(We), !e) throw "";
    const t = new Worker(e, {
      name: r?.name
    });
    return t.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(e);
    }), t;
  } catch {
    return new Worker(
      "data:text/javascript;charset=utf-8," + encodeURIComponent(Ye),
      {
        name: r?.name
      }
    );
  }
}
class Qe {
  check() {
    return typeof globalThis.MediaStreamTrackProcessor < "u" && typeof globalThis.VideoTrackGenerator < "u";
  }
}
ut("IsSupportedWorkerized", Qe);
async function cr() {
  return new Promise(async (r, e) => {
    !mt() && (await Xe() || Je()) ? r() : e(
      "Your browser does not support the MediaStreamTrack API for Insertable Streams of Media."
    );
  });
}
function Je() {
  return self.MediaStreamTrackProcessor !== void 0 && self.MediaStreamTrackGenerator !== void 0 || bt();
}
function bt() {
  return [
    self.ReadableStream,
    self.WritableStream,
    self.MediaStream,
    self.OffscreenCanvas,
    self.VideoFrame,
    self.AudioContext,
    self.AudioWorkletNode
  ].filter((r) => r === void 0).length === 0;
}
function mt() {
  const r = navigator.userAgent.toLowerCase();
  return !(navigator.vendor && navigator.vendor.toLowerCase().indexOf("apple") > -1 && !(r.indexOf("applewebkit") > -1 && r.indexOf("version") === -1)) ? !1 : parseInt((r.split(" ").find((s) => s.includes("version/")) ?? "/0").split("/")[1]) < 26;
}
function Xe() {
  return ct(Qe, yt).then(async (r) => {
    const e = await r.check();
    return await r.terminate(), e;
  }).catch(() => !1);
}
const m = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), se = /* @__PURE__ */ Symbol("anyProducer"), Ce = Promise.resolve(), ie = /* @__PURE__ */ Symbol("listenerAdded"), ne = /* @__PURE__ */ Symbol("listenerRemoved");
let oe = !1, ye = !1;
const ae = (r) => typeof r == "string" || typeof r == "symbol" || typeof r == "number";
function M(r) {
  if (!ae(r))
    throw new TypeError("`eventName` must be a string, symbol, or number");
}
function q(r) {
  if (typeof r != "function")
    throw new TypeError("listener must be a function");
}
function I(r, e) {
  const t = S.get(r);
  if (t.has(e))
    return t.get(e);
}
function G(r, e) {
  const t = ae(e) ? e : se, s = p.get(r);
  if (s.has(t))
    return s.get(t);
}
function wt(r, e, t) {
  const s = p.get(r);
  if (s.has(e))
    for (const i of s.get(e))
      i.enqueue(t);
  if (s.has(se)) {
    const i = Promise.all([e, t]);
    for (const o of s.get(se))
      o.enqueue(i);
  }
}
function xe(r, e) {
  e = Array.isArray(e) ? e : [e];
  let t = !1, s = () => {
  }, i = [];
  const o = {
    enqueue(n) {
      i.push(n), s();
    },
    finish() {
      t = !0, s();
    }
  };
  for (const n of e) {
    let a = G(r, n);
    a || (a = /* @__PURE__ */ new Set(), p.get(r).set(n, a)), a.add(o);
  }
  return {
    async next() {
      return i ? i.length === 0 ? t ? (i = void 0, this.next()) : (await new Promise((n) => {
        s = n;
      }), this.next()) : {
        done: !1,
        value: await i.shift()
      } : { done: !0 };
    },
    async return(n) {
      i = void 0;
      for (const a of e) {
        const l = G(r, a);
        l && (l.delete(o), l.size === 0 && p.get(r).delete(a));
      }
      return s(), arguments.length > 0 ? { done: !0, value: await n } : { done: !0 };
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function ze(r) {
  if (r === void 0)
    return je;
  if (!Array.isArray(r))
    throw new TypeError("`methodNames` must be an array of strings");
  for (const e of r)
    if (!je.includes(e))
      throw typeof e != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${e} is not Emittery method`);
  return r;
}
const O = (r) => r === ie || r === ne;
function Y(r, e, t) {
  if (O(e))
    try {
      oe = !0, r.emit(e, t);
    } finally {
      oe = !1;
    }
}
let j = class _e {
  static mixin(e, t) {
    return t = ze(t), (s) => {
      if (typeof s != "function")
        throw new TypeError("`target` must be function");
      for (const n of t)
        if (s.prototype[n] !== void 0)
          throw new Error(`The property \`${n}\` already exists on \`target\``);
      function i() {
        return Object.defineProperty(this, e, {
          enumerable: !1,
          value: new _e()
        }), this[e];
      }
      Object.defineProperty(s.prototype, e, {
        enumerable: !1,
        get: i
      });
      const o = (n) => function(...a) {
        return this[e][n](...a);
      };
      for (const n of t)
        Object.defineProperty(s.prototype, n, {
          enumerable: !1,
          value: o(n)
        });
      return s;
    };
  }
  static get isDebugEnabled() {
    if (typeof globalThis.process?.env != "object")
      return ye;
    const { env: e } = globalThis.process ?? { env: {} };
    return e.DEBUG === "emittery" || e.DEBUG === "*" || ye;
  }
  static set isDebugEnabled(e) {
    ye = e;
  }
  constructor(e = {}) {
    m.set(this, /* @__PURE__ */ new Set()), S.set(this, /* @__PURE__ */ new Map()), p.set(this, /* @__PURE__ */ new Map()), p.get(this).set(se, /* @__PURE__ */ new Set()), this.debug = e.debug ?? {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (t, s, i, o) => {
      try {
        o = JSON.stringify(o);
      } catch {
        o = `Object with the following keys failed to stringify: ${Object.keys(o).join(",")}`;
      }
      (typeof i == "symbol" || typeof i == "number") && (i = i.toString());
      const n = /* @__PURE__ */ new Date(), a = `${n.getHours()}:${n.getMinutes()}:${n.getSeconds()}.${n.getMilliseconds()}`;
      console.log(`[${a}][emittery:${t}][${s}] Event Name: ${i}
	data: ${o}`);
    });
  }
  logIfDebugEnabled(e, t, s) {
    (_e.isDebugEnabled || this.debug.enabled) && this.debug.logger(e, this.debug.name, t, s);
  }
  on(e, t, { signal: s } = {}) {
    q(t), e = Array.isArray(e) ? e : [e];
    for (const o of e) {
      M(o);
      let n = I(this, o);
      n || (n = /* @__PURE__ */ new Set(), S.get(this).set(o, n)), n.add(t), this.logIfDebugEnabled("subscribe", o, void 0), O(o) || Y(this, ie, { eventName: o, listener: t });
    }
    const i = () => {
      this.off(e, t), s?.removeEventListener("abort", i);
    };
    return s?.addEventListener("abort", i, { once: !0 }), s?.aborted && i(), i;
  }
  off(e, t) {
    q(t), e = Array.isArray(e) ? e : [e];
    for (const s of e) {
      M(s);
      const i = I(this, s);
      i && (i.delete(t), i.size === 0 && S.get(this).delete(s)), this.logIfDebugEnabled("unsubscribe", s, void 0), O(s) || Y(this, ne, { eventName: s, listener: t });
    }
  }
  once(e, t) {
    if (t !== void 0 && typeof t != "function")
      throw new TypeError("predicate must be a function");
    let s;
    const i = new Promise((o) => {
      s = this.on(e, (n) => {
        t && !t(n) || (s(), o(n));
      });
    });
    return i.off = s, i;
  }
  events(e) {
    e = Array.isArray(e) ? e : [e];
    for (const t of e)
      M(t);
    return xe(this, e);
  }
  async emit(e, t) {
    if (M(e), O(e) && !oe)
      throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
    this.logIfDebugEnabled("emit", e, t), wt(this, e, t);
    const s = I(this, e) ?? /* @__PURE__ */ new Set(), i = m.get(this), o = [...s], n = O(e) ? [] : [...i];
    await Ce, await Promise.all([
      ...o.map(async (a) => {
        if (s.has(a))
          return a(t);
      }),
      ...n.map(async (a) => {
        if (i.has(a))
          return a(e, t);
      })
    ]);
  }
  async emitSerial(e, t) {
    if (M(e), O(e) && !oe)
      throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
    this.logIfDebugEnabled("emitSerial", e, t);
    const s = I(this, e) ?? /* @__PURE__ */ new Set(), i = m.get(this), o = [...s], n = [...i];
    await Ce;
    for (const a of o)
      s.has(a) && await a(t);
    for (const a of n)
      i.has(a) && await a(e, t);
  }
  onAny(e, { signal: t } = {}) {
    q(e), this.logIfDebugEnabled("subscribeAny", void 0, void 0), m.get(this).add(e), Y(this, ie, { listener: e });
    const s = () => {
      this.offAny(e), t?.removeEventListener("abort", s);
    };
    return t?.addEventListener("abort", s, { once: !0 }), t?.aborted && s(), s;
  }
  anyEvent() {
    return xe(this);
  }
  offAny(e) {
    q(e), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), Y(this, ne, { listener: e }), m.get(this).delete(e);
  }
  clearListeners(e) {
    e = Array.isArray(e) ? e : [e];
    for (const t of e)
      if (this.logIfDebugEnabled("clear", t, void 0), ae(t)) {
        const s = I(this, t);
        s && s.clear();
        const i = G(this, t);
        if (i) {
          for (const o of i)
            o.finish();
          i.clear();
        }
      } else {
        m.get(this).clear();
        for (const [s, i] of S.get(this).entries())
          i.clear(), S.get(this).delete(s);
        for (const [s, i] of p.get(this).entries()) {
          for (const o of i)
            o.finish();
          i.clear(), p.get(this).delete(s);
        }
      }
  }
  listenerCount(e) {
    e = Array.isArray(e) ? e : [e];
    let t = 0;
    for (const s of e) {
      if (ae(s)) {
        t += m.get(this).size + (I(this, s)?.size ?? 0) + (G(this, s)?.size ?? 0) + (G(this)?.size ?? 0);
        continue;
      }
      s !== void 0 && M(s), t += m.get(this).size;
      for (const i of S.get(this).values())
        t += i.size;
      for (const i of p.get(this).values())
        t += i.size;
    }
    return t;
  }
  bindMethods(e, t) {
    if (typeof e != "object" || e === null)
      throw new TypeError("`target` must be an object");
    t = ze(t);
    for (const s of t) {
      if (e[s] !== void 0)
        throw new Error(`The property \`${s}\` already exists on \`target\``);
      Object.defineProperty(e, s, {
        enumerable: !1,
        value: this[s].bind(this)
      });
    }
  }
};
const je = Object.getOwnPropertyNames(j.prototype).filter((r) => r !== "constructor");
Object.defineProperty(j, "listenerAdded", {
  value: ie,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
Object.defineProperty(j, "listenerRemoved", {
  value: ne,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
var Et = Object.defineProperty, _t = (r, e, t) => e in r ? Et(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, Tt = (r, e, t) => (_t(r, e + "", t), t), St = /* @__PURE__ */ ((r) => (r.automation = "automation", r.test = "test", r.vbc = "vbc", r.video = "video", r.voice = "voice", r))(St || {});
const vt = "hlg.tokbox.com/prod/logging/vcp_webrtc", At = "https://", kt = 1e4, f = [];
for (let r = 0; r < 256; ++r)
  f.push((r + 256).toString(16).slice(1));
function Mt(r, e = 0) {
  return (f[r[e + 0]] + f[r[e + 1]] + f[r[e + 2]] + f[r[e + 3]] + "-" + f[r[e + 4]] + f[r[e + 5]] + "-" + f[r[e + 6]] + f[r[e + 7]] + "-" + f[r[e + 8]] + f[r[e + 9]] + "-" + f[r[e + 10]] + f[r[e + 11]] + f[r[e + 12]] + f[r[e + 13]] + f[r[e + 14]] + f[r[e + 15]]).toLowerCase();
}
const It = new Uint8Array(16);
function Pt() {
  return crypto.getRandomValues(It);
}
function $t(r, e, t) {
  return crypto.randomUUID ? crypto.randomUUID() : Rt(r);
}
function Rt(r, e, t) {
  var s, i, o;
  r = r || {};
  const n = (o = (i = r.random) != null ? i : (s = r.rng) == null ? void 0 : s.call(r)) != null ? o : Pt();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, Mt(n);
}
function Ae(r, e) {
  globalThis.vonage || (globalThis.vonage = {}), globalThis.vonage.workerizer || (globalThis.vonage.workerizer = {});
  let t = globalThis.vonage.workerizer;
  return t[r] || (t[r] = e), t[r];
}
const E = Ae(
  "globals",
  {}
);
var _ = /* @__PURE__ */ ((r) => (r.INIT = "INIT", r.FORWARD = "FORWARD", r.TERMINATE = "TERMINATE", r.GLOBALS_SYNC = "GLOBALS_SYNC", r.EVENT = "EVENT", r))(_ || {});
function Ze(r) {
  var e;
  return [
    typeof ImageBitmap < "u" ? ImageBitmap : void 0,
    typeof ReadableStream < "u" ? ReadableStream : void 0,
    typeof WritableStream < "u" ? WritableStream : void 0,
    typeof MediaStreamTrack < "u" ? MediaStreamTrack : void 0,
    (e = globalThis.MediaStreamTrackHandle) != null ? e : void 0
  ].some((s) => s && r instanceof s);
}
let Ot = 0;
function Lt(r, e, t, s, i) {
  const o = Ot++;
  return r.postMessage(
    {
      id: o,
      type: e,
      functionName: t,
      args: s
    },
    s.filter((a) => Ze(a))
  ), new Promise((a) => {
    i?.set(o, a);
  });
}
function x(r, e) {
  const { id: t, type: s } = r, i = Array.isArray(e) ? e : [e];
  postMessage(
    {
      id: t,
      type: s,
      result: e
    },
    i.filter((o) => Ze(o))
  );
}
const Fe = Ae("workerized", {});
function Ke() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
async function Wt() {
  if (Ke())
    x({ type: _.GLOBALS_SYNC }, E);
  else {
    const r = [];
    for (const e in Fe) {
      const { worker: t, resolvers: s } = Fe[e].workerContext;
      t && r.push(
        Lt(
          t,
          _.GLOBALS_SYNC,
          "",
          [E],
          s
        )
      );
    }
    await Promise.all(r);
  }
}
function le(r, e) {
  if (Array.isArray(e))
    e.splice(0, e.length);
  else if (typeof e == "object")
    for (const t in e)
      delete e[t];
  for (const t in r)
    Array.isArray(r[t]) ? (e[t] = [], le(r[t], e[t])) : typeof r[t] == "object" ? (e[t] = {}, le(r[t], e[t])) : e[t] = r[t];
}
const w = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap(), ce = /* @__PURE__ */ Symbol("anyProducer"), Ge = Promise.resolve(), fe = /* @__PURE__ */ Symbol("listenerAdded"), ue = /* @__PURE__ */ Symbol("listenerRemoved");
let de = !1, be = !1;
function P(r) {
  if (typeof r != "string" && typeof r != "symbol" && typeof r != "number")
    throw new TypeError("`eventName` must be a string, symbol, or number");
}
function Q(r) {
  if (typeof r != "function")
    throw new TypeError("listener must be a function");
}
function $(r, e) {
  const t = v.get(r);
  if (t.has(e))
    return t.get(e);
}
function D(r, e) {
  const t = typeof e == "string" || typeof e == "symbol" || typeof e == "number" ? e : ce, s = g.get(r);
  if (s.has(t))
    return s.get(t);
}
function Ct(r, e, t) {
  const s = g.get(r);
  if (s.has(e))
    for (const i of s.get(e))
      i.enqueue(t);
  if (s.has(ce)) {
    const i = Promise.all([e, t]);
    for (const o of s.get(ce))
      o.enqueue(i);
  }
}
function De(r, e) {
  e = Array.isArray(e) ? e : [e];
  let t = !1, s = () => {
  }, i = [];
  const o = {
    enqueue(n) {
      i.push(n), s();
    },
    finish() {
      t = !0, s();
    }
  };
  for (const n of e) {
    let a = D(r, n);
    a || (a = /* @__PURE__ */ new Set(), g.get(r).set(n, a)), a.add(o);
  }
  return {
    async next() {
      return i ? i.length === 0 ? t ? (i = void 0, this.next()) : (await new Promise((n) => {
        s = n;
      }), this.next()) : {
        done: !1,
        value: await i.shift()
      } : { done: !0 };
    },
    async return(n) {
      i = void 0;
      for (const a of e) {
        const l = D(r, a);
        l && (l.delete(o), l.size === 0 && g.get(r).delete(a));
      }
      return s(), arguments.length > 0 ? { done: !0, value: await n } : { done: !0 };
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function Ue(r) {
  if (r === void 0)
    return Be;
  if (!Array.isArray(r))
    throw new TypeError("`methodNames` must be an array of strings");
  for (const e of r)
    if (!Be.includes(e))
      throw typeof e != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${e} is not Emittery method`);
  return r;
}
const L = (r) => r === fe || r === ue;
function J(r, e, t) {
  if (L(e))
    try {
      de = !0, r.emit(e, t);
    } finally {
      de = !1;
    }
}
class z {
  static mixin(e, t) {
    return t = Ue(t), (s) => {
      if (typeof s != "function")
        throw new TypeError("`target` must be function");
      for (const n of t)
        if (s.prototype[n] !== void 0)
          throw new Error(`The property \`${n}\` already exists on \`target\``);
      function i() {
        return Object.defineProperty(this, e, {
          enumerable: !1,
          value: new z()
        }), this[e];
      }
      Object.defineProperty(s.prototype, e, {
        enumerable: !1,
        get: i
      });
      const o = (n) => function(...a) {
        return this[e][n](...a);
      };
      for (const n of t)
        Object.defineProperty(s.prototype, n, {
          enumerable: !1,
          value: o(n)
        });
      return s;
    };
  }
  static get isDebugEnabled() {
    var e, t;
    if (typeof ((e = globalThis.process) == null ? void 0 : e.env) != "object")
      return be;
    const { env: s } = (t = globalThis.process) != null ? t : { env: {} };
    return s.DEBUG === "emittery" || s.DEBUG === "*" || be;
  }
  static set isDebugEnabled(e) {
    be = e;
  }
  constructor(e = {}) {
    var t;
    w.set(this, /* @__PURE__ */ new Set()), v.set(this, /* @__PURE__ */ new Map()), g.set(this, /* @__PURE__ */ new Map()), g.get(this).set(ce, /* @__PURE__ */ new Set()), this.debug = (t = e.debug) != null ? t : {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (s, i, o, n) => {
      try {
        n = JSON.stringify(n);
      } catch {
        n = `Object with the following keys failed to stringify: ${Object.keys(n).join(",")}`;
      }
      (typeof o == "symbol" || typeof o == "number") && (o = o.toString());
      const a = /* @__PURE__ */ new Date(), l = `${a.getHours()}:${a.getMinutes()}:${a.getSeconds()}.${a.getMilliseconds()}`;
      console.log(`[${l}][emittery:${s}][${i}] Event Name: ${o}
	data: ${n}`);
    });
  }
  logIfDebugEnabled(e, t, s) {
    (z.isDebugEnabled || this.debug.enabled) && this.debug.logger(e, this.debug.name, t, s);
  }
  on(e, t) {
    Q(t), e = Array.isArray(e) ? e : [e];
    for (const s of e) {
      P(s);
      let i = $(this, s);
      i || (i = /* @__PURE__ */ new Set(), v.get(this).set(s, i)), i.add(t), this.logIfDebugEnabled("subscribe", s, void 0), L(s) || J(this, fe, { eventName: s, listener: t });
    }
    return this.off.bind(this, e, t);
  }
  off(e, t) {
    Q(t), e = Array.isArray(e) ? e : [e];
    for (const s of e) {
      P(s);
      const i = $(this, s);
      i && (i.delete(t), i.size === 0 && v.get(this).delete(s)), this.logIfDebugEnabled("unsubscribe", s, void 0), L(s) || J(this, ue, { eventName: s, listener: t });
    }
  }
  once(e) {
    let t;
    const s = new Promise((i) => {
      t = this.on(e, (o) => {
        t(), i(o);
      });
    });
    return s.off = t, s;
  }
  events(e) {
    e = Array.isArray(e) ? e : [e];
    for (const t of e)
      P(t);
    return De(this, e);
  }
  async emit(e, t) {
    var s;
    if (P(e), L(e) && !de)
      throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
    this.logIfDebugEnabled("emit", e, t), Ct(this, e, t);
    const i = (s = $(this, e)) != null ? s : /* @__PURE__ */ new Set(), o = w.get(this), n = [...i], a = L(e) ? [] : [...o];
    await Ge, await Promise.all([
      ...n.map(async (l) => {
        if (i.has(l))
          return l(t);
      }),
      ...a.map(async (l) => {
        if (o.has(l))
          return l(e, t);
      })
    ]);
  }
  async emitSerial(e, t) {
    var s;
    if (P(e), L(e) && !de)
      throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
    this.logIfDebugEnabled("emitSerial", e, t);
    const i = (s = $(this, e)) != null ? s : /* @__PURE__ */ new Set(), o = w.get(this), n = [...i], a = [...o];
    await Ge;
    for (const l of n)
      i.has(l) && await l(t);
    for (const l of a)
      o.has(l) && await l(e, t);
  }
  onAny(e) {
    return Q(e), this.logIfDebugEnabled("subscribeAny", void 0, void 0), w.get(this).add(e), J(this, fe, { listener: e }), this.offAny.bind(this, e);
  }
  anyEvent() {
    return De(this);
  }
  offAny(e) {
    Q(e), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), J(this, ue, { listener: e }), w.get(this).delete(e);
  }
  clearListeners(e) {
    e = Array.isArray(e) ? e : [e];
    for (const t of e)
      if (this.logIfDebugEnabled("clear", t, void 0), typeof t == "string" || typeof t == "symbol" || typeof t == "number") {
        const s = $(this, t);
        s && s.clear();
        const i = D(this, t);
        if (i) {
          for (const o of i)
            o.finish();
          i.clear();
        }
      } else {
        w.get(this).clear();
        for (const [s, i] of v.get(this).entries())
          i.clear(), v.get(this).delete(s);
        for (const [s, i] of g.get(this).entries()) {
          for (const o of i)
            o.finish();
          i.clear(), g.get(this).delete(s);
        }
      }
  }
  listenerCount(e) {
    var t, s, i, o, n, a;
    e = Array.isArray(e) ? e : [e];
    let l = 0;
    for (const c of e) {
      if (typeof c == "string") {
        l += w.get(this).size + ((s = (t = $(this, c)) == null ? void 0 : t.size) != null ? s : 0) + ((o = (i = D(this, c)) == null ? void 0 : i.size) != null ? o : 0) + ((a = (n = D(this)) == null ? void 0 : n.size) != null ? a : 0);
        continue;
      }
      typeof c < "u" && P(c), l += w.get(this).size;
      for (const u of v.get(this).values())
        l += u.size;
      for (const u of g.get(this).values())
        l += u.size;
    }
    return l;
  }
  bindMethods(e, t) {
    if (typeof e != "object" || e === null)
      throw new TypeError("`target` must be an object");
    t = Ue(t);
    for (const s of t) {
      if (e[s] !== void 0)
        throw new Error(`The property \`${s}\` already exists on \`target\``);
      Object.defineProperty(e, s, {
        enumerable: !1,
        value: this[s].bind(this)
      });
    }
  }
}
const Be = Object.getOwnPropertyNames(z.prototype).filter((r) => r !== "constructor");
Object.defineProperty(z, "listenerAdded", {
  value: fe,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
Object.defineProperty(z, "listenerRemoved", {
  value: ue,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
function xt(r) {
  return r.onAny && r.emit;
}
async function zt(r, e) {
  const { functionName: t, args: s } = r;
  if (!e.instance)
    throw "instance not initialized";
  if (!t)
    throw "missing function name to call";
  if (!e.instance[t])
    throw `undefined function [${t}] in class ${e.instance.constructor.workerId}`;
  x(r, await e.instance[t](...s ?? []));
}
const jt = Ae("registeredWorkers", {});
function Ft(r, e) {
  if (!r.args)
    throw "Missing className while initializing worker";
  const [t, s] = r.args, i = jt[t];
  if (i)
    e.instance = new i(r.args.slice(1));
  else
    throw `unknown worker class ${t}`;
  le(s, E), xt(e.instance) && e.instance.onAny((o, n) => {
    x(
      {
        type: _.EVENT
      },
      { name: o, data: n }
    );
  }), x(r, typeof e.instance !== void 0);
}
async function Gt(r, e) {
  const { args: t } = r;
  if (!e.instance)
    throw "instance not initialized";
  let s;
  e.instance.terminate && (s = await e.instance.terminate(...t ?? [])), x(r, s);
}
function Dt(r) {
  if (!r.args)
    throw "Missing globals while syncing";
  le(r.args[0], E), x(r, {});
}
function Ut() {
  const r = {};
  onmessage = async (e) => {
    const t = e.data;
    switch (t.type) {
      case _.INIT:
        Ft(t, r);
        break;
      case _.FORWARD:
        zt(t, r);
        break;
      case _.TERMINATE:
        Gt(t, r);
        break;
      case _.GLOBALS_SYNC:
        Dt(t);
        break;
    }
  };
}
Ke() && Ut();
function Bt(r, e) {
  return E[r] || (E[r] = e), [
    () => E[r],
    async (t) => {
      E[r] = t, await Wt();
    }
  ];
}
function Ht(r, e) {
  return Bt(r, e);
}
const [Vt, qt] = Ht("metadata");
function fr(r) {
  qt(r);
}
function me() {
  return Vt();
}
class ke {
  constructor(e, t) {
    Tt(this, "uuid"), this.config = e, this.uuid = t ?? $t();
  }
  async send(e) {
    var t, s, i;
    const { appId: o, sourceType: n } = (t = me()) != null ? t : {};
    if (!o || !n)
      return "metadata missing";
    const a = new AbortController(), l = setTimeout(() => a.abort(), kt);
    return await ((i = (s = this.config) == null ? void 0 : s.fetch) != null ? i : fetch)(this.getUrl(), {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(this.buildReport(e)),
      signal: a.signal
    }), clearTimeout(l), "success";
  }
  getUrl() {
    var e;
    let t = (e = me().proxyUrl) != null ? e : At;
    return t += (t.at(-1) === "/" ? "" : "/") + vt, t;
  }
  getHeaders() {
    return {
      "Content-Type": "application/json"
    };
  }
  buildReport(e) {
    const t = me();
    return {
      guid: this.uuid,
      ...e,
      applicationId: t.appId,
      timestamp: Date.now(),
      proxyUrl: t.proxyUrl,
      source: t.sourceType
    };
  }
}
const X = "3.0.7", he = class he {
};
he.updates = {
  transformer_new: "New transformer",
  transformer_null: "Null transformer"
}, he.errors = {
  transformer_none: "No transformers provided",
  transformer_start: "Cannot start transformer",
  transformer_transform: "Cannot transform frame",
  transformer_flush: "Cannot flush transformer",
  readable_null: "Readable is null",
  writable_null: "Writable is null"
};
let y = he;
function Yt(r) {
  return typeof r == "object" && r !== null && "message" in r && typeof r.message == "string";
}
function Qt(r) {
  if (Yt(r)) return r;
  try {
    return new Error(JSON.stringify(r));
  } catch {
    return new Error(String(r));
  }
}
function we(r) {
  return Qt(r).message;
}
class Jt {
  constructor(e, t) {
    this.config = e, this.frameTransformedCount = 0, this.frameFromSourceCount = 0, this.startAt = 0, this.reporter = new ke(e, t);
  }
  async onFrameFromSource() {
    this.frameFromSourceCount++;
  }
  get fps() {
    const { startAt: e, frameFromSourceCount: t } = this, i = (Date.now() - e) / 1e3;
    return t / i;
  }
  async onFrameTransformed(e = {}, t = !1) {
    this.startAt === 0 && (this.startAt = Date.now()), this.frameTransformedCount++;
    const { startAt: s, frameTransformedCount: i, frameFromSourceCount: o } = this, n = Date.now(), a = (n - s) / 1e3, l = i / a, c = o / a;
    return t || this.frameTransformedCount >= this.config.loggingIntervalFrameCount ? (this.frameFromSourceCount = 0, this.frameTransformedCount = 0, this.startAt = n, this.reporter.config = this.config, this.reporter.send({
      ...this.config.report,
      variation: "QoS",
      fps: c,
      transformedFps: l,
      framesTransformed: i,
      ...e
    })) : "success";
  }
}
var Xt = /* @__PURE__ */ ((r) => (r.FPS_DROP = "fps_drop", r))(Xt || {}), Zt = /* @__PURE__ */ ((r) => (r.start = "start", r.transform = "transform", r.flush = "flush", r))(Zt || {}), Te = /* @__PURE__ */ ((r) => (r.pipeline_ended = "pipeline_ended", r.pipeline_ended_with_error = "pipeline_ended_with_error", r.pipeline_started = "pipeline_started", r.pipeline_started_with_error = "pipeline_started_with_error", r.pipeline_restarted = "pipeline_restarted", r.pipeline_restarted_with_error = "pipeline_restarted_with_error", r))(Te || {});
const Kt = 500, Nt = 0.8;
class er extends j {
  constructor(e, t) {
    super(), this.reporter_ = new ke(), this.reporterQos_ = new Jt({
      loggingIntervalFrameCount: Kt,
      report: {
        version: X
      }
    }), this.index_ = t, this.transformer_ = e, this.shouldStop_ = !1, this.isFlashed_ = !1, this.mediaTransformerQosReportStartTimestamp_ = 0, this.videoHeight_ = 0, this.videoWidth_ = 0, this.trackExpectedRate_ = -1, this.transformerType_ = "Custom", "getTransformerType" in e && (this.transformerType_ = e.getTransformerType()), this.report({
      variation: "Create"
    });
  }
  setTrackExpectedRate(e) {
    this.trackExpectedRate_ = e;
  }
  async start(e) {
    if (this.controller_ = e, this.transformer_ && typeof this.transformer_.start == "function")
      try {
        await this.transformer_.start(e);
      } catch (t) {
        this.report({
          message: y.errors.transformer_start,
          variation: "Error",
          error: we(t)
        });
        const s = {
          eventMetaData: { transformerIndex: this.index_ },
          error: t,
          function: "start"
          /* start */
        };
        this.emit("error", s);
      }
  }
  async transform(e, t) {
    if (this.mediaTransformerQosReportStartTimestamp_ === 0 && (this.mediaTransformerQosReportStartTimestamp_ = Date.now()), e instanceof VideoFrame && (this.videoHeight_ = e?.displayHeight ?? 0, this.videoWidth_ = e?.displayWidth ?? 0), this.reporterQos_.onFrameFromSource(), this.transformer_)
      if (this.shouldStop_)
        console.warn("[Pipeline] flush from transform"), e.close(), this.flush(t), t.terminate();
      else {
        try {
          await this.transformer_.transform?.(e, t), this.reportQos();
        } catch (s) {
          this.report({
            message: y.errors.transformer_transform,
            variation: "Error",
            error: we(s)
          });
          const i = {
            eventMetaData: { transformerIndex: this.index_ },
            error: s,
            function: "transform"
            /* transform */
          };
          this.emit("error", i);
        }
        if (this.trackExpectedRate_ != -1 && this.trackExpectedRate_ * Nt > this.reporterQos_.fps) {
          const s = {
            eventMetaData: {
              transformerIndex: this.index_
            },
            warningType: "fps_drop",
            dropInfo: {
              requested: this.trackExpectedRate_,
              current: this.reporterQos_.fps
            }
          };
          this.emit("warn", s);
        }
      }
  }
  async flush(e) {
    if (this.transformer_ && typeof this.transformer_.flush == "function" && !this.isFlashed_) {
      this.isFlashed_ = !0;
      try {
        await this.transformer_.flush(e);
      } catch (t) {
        this.report({
          message: y.errors.transformer_flush,
          variation: "Error",
          error: we(t)
        });
        const s = {
          eventMetaData: { transformerIndex: this.index_ },
          error: t,
          function: "flush"
          /* flush */
        };
        this.emit("error", s);
      }
    }
    this.reportQos(!0), this.report({
      variation: "Delete"
    });
  }
  stop() {
    console.log("[Pipeline] Stop stream."), this.controller_ && (this.flush(this.controller_), this.controller_.terminate()), this.shouldStop_ = !0;
  }
  report(e) {
    this.reporter_.send({
      version: X,
      action: "MediaTransformer",
      transformerType: this.transformerType_,
      ...e
    });
  }
  reportQos(e = !1) {
    this.reporterQos_.config = {
      ...this.reporterQos_.config
    }, this.reporterQos_.onFrameTransformed(
      {
        version: X,
        action: "MediaTransformer",
        transformerType: this.transformerType_,
        videoWidth: this.videoWidth_,
        videoHeight: this.videoHeight_
      },
      e
    );
  }
}
class tr extends j {
  constructor(e) {
    super(), this.transformers_ = [], this.trackExpectedRate_ = -1;
    for (let t = 0; t < e.length; t++) {
      let s = new er(e[t], t);
      s.on("error", (i) => {
        this.emit("error", i);
      }), s.on("warn", (i) => {
        this.emit("warn", i);
      }), this.transformers_.push(s);
    }
  }
  setTrackExpectedRate(e) {
    this.trackExpectedRate_ = e;
    for (let t of this.transformers_)
      t.setTrackExpectedRate(this.trackExpectedRate_);
  }
  async start(e, t) {
    if (!this.transformers_ || this.transformers_.length === 0) {
      console.log("[Pipeline] No transformers.");
      return;
    }
    try {
      let s = e;
      for (let i of this.transformers_)
        e = e.pipeThrough(
          new TransformStream(i)
        );
      e.pipeTo(t).then(async () => {
        console.log("[Pipeline] Setup."), await t.abort(), await s.cancel(), this.emit(
          "pipelineInfo",
          "pipeline_ended"
          /* pipeline_ended */
        );
      }).catch(async (i) => {
        e.cancel().then(() => {
          console.log(
            "[Pipeline] Shutting down streams after abort."
          );
        }).catch((o) => {
          console.error(
            "[Pipeline] Error from stream transform:",
            o
          );
        }), await t.abort(i), await s.cancel(i), this.emit(
          "pipelineInfo",
          "pipeline_ended_with_error"
          /* pipeline_ended_with_error */
        );
      });
    } catch {
      this.emit(
        "pipelineInfo",
        "pipeline_started_with_error"
        /* pipeline_started_with_error */
      ), this.destroy();
      return;
    }
    this.emit(
      "pipelineInfo",
      "pipeline_started"
      /* pipeline_started */
    ), console.log("[Pipeline] Pipeline started.");
  }
  async destroy() {
    console.log("[Pipeline] Destroying Pipeline.");
    for (let e of this.transformers_)
      e.stop();
  }
}
function Ne() {
  return typeof MediaStreamTrackHandle < "u";
}
function He(r) {
  return Ne() && r instanceof MediaStreamTrackHandle;
}
function rr(r) {
  return Ne() ? new MediaStreamTrackHandle(r) : r.clone();
}
class sr extends j {
  constructor() {
    super(), this.reporter_ = new ke(), this.trackExpectedRate_ = -1, this.report({
      variation: "Create"
    });
  }
  /**
   * Sets the expected rate of the track per second.
   * The media processor will use this number for calculating drops in the rate.
   * This could happen when the transformation will take more time than expected.
   * This will not cause an error, just warning to the client.
   * Mostly:
   * Video: 30 frames per second
   * Audio: 50 audio data per second for OPUS
   * In case of increased frame dropping rate a warning will be emitted according to info [here](/docs/intro#errors-and-warnings-listener).
   * ***This is an optional method.***
   * @param trackExpectedRate - number holds the predicted track rate.
   */
  setTrackExpectedRate(e) {
    this.trackExpectedRate_ = e, this.pipeline_ && this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_);
  }
  async transform(e, t) {
    if (this.isTrack(e)) {
      if (He(e) || e.kind === "video") {
        const s = new MediaStreamTrackProcessor({ track: e }), i = new VideoTrackGenerator();
        return this.readable_ = s.readable, this.writable_ = i.writable, await this.transformInternal(), i.track;
      }
      throw Error("Cannot process audio tracks inside a web worker when passing a track to transform");
    } else
      return this.readable_ = e, this.writable_ = t, this.transformInternal();
  }
  /**
   * @private
   */
  transformInternal() {
    return new Promise(async (e, t) => {
      if (!this.transformers_ || this.transformers_.length === 0) {
        this.report({
          message: y.errors.transformer_none,
          variation: "Error"
        }), t("[MediaProcessor] Need to set transformers.");
        return;
      }
      if (!this.readable_) {
        this.report({
          variation: "Error",
          message: y.errors.readable_null
        }), t("[MediaProcessor] Readable is null.");
        return;
      }
      if (!this.writable_) {
        this.report({
          variation: "Error",
          message: y.errors.writable_null
        }), t("[MediaProcessor] Writable is null.");
        return;
      }
      let s = !1;
      this.pipeline_ && (s = !0, this.pipeline_.clearListeners(), this.pipeline_.destroy()), this.pipeline_ = new tr(this.transformers_), this.pipeline_.on("warn", (i) => {
        this.emit("warn", i);
      }), this.pipeline_.on("error", (i) => {
        this.emit("error", i);
      }), this.pipeline_.on("pipelineInfo", (i) => {
        s && (i === "pipeline_started" ? i = Te.pipeline_restarted : i === "pipeline_started_with_error" && (i = Te.pipeline_restarted_with_error)), this.emit("pipelineInfo", i);
      }), this.trackExpectedRate_ != -1 && this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_), this.pipeline_.start(this.readable_, this.writable_).then(() => {
        e();
      }).catch((i) => {
        t(i);
      });
    });
  }
  /**
   * Sets an array of transfromer instances that will be hold and ran by the media processor instance.
   * See example [here](/docs/intro#main-code)
   *
   * @param transformers An array of transformer instances.
   *
   * @returns
   */
  setTransformers(e) {
    return this.report({
      variation: "Update",
      message: y.updates.transformer_new
    }), this.transformers_ = e, this.readable_ && this.writable_ ? this.transformInternal() : Promise.resolve();
  }
  /**
   * Stops running the tranformation logic performed by the media processor instance.
   * @returns
   */
  destroy() {
    return new Promise(async (e) => {
      this.pipeline_ && this.pipeline_.destroy(), this.report({ variation: "Delete" }), e();
    });
  }
  report(e) {
    this.reporter_.send({
      version: X,
      action: "MediaProcessor",
      ...e
    });
  }
  isTrack(e) {
    return He(e) ? !0 : "kind" in e;
  }
}
class ir {
  constructor({ kind: e }) {
    if (e == "video") {
      const t = document.createElement("canvas"), s = t.getContext("2d", {
        desynchronized: !0
      }), i = t.captureStream().getVideoTracks()[0];
      return i.writable = new WritableStream({
        write(o) {
          t.width = o.displayWidth, t.height = o.displayHeight, s.drawImage(o, 0, 0, t.width, t.height), o.close(), typeof i.requestFrame == "function" && i.requestFrame();
        }
      }), i;
    } else if (e == "audio") {
      const t = new AudioContext(), s = t.createMediaStreamDestination(), [i] = s.stream.getAudioTracks();
      return i.writable = new WritableStream({
        async start(o) {
          this.arrays = [];
          function n() {
            registerProcessor(
              "mstg-shim",
              class extends AudioWorkletProcessor {
                constructor() {
                  super(), this.arrays = [], this.arrayOffset = 0, this.port.onmessage = ({ data: l }) => this.arrays.push(l), this.emptyArray = new Float32Array(0);
                }
                process(l, [[c]]) {
                  for (let u = 0; u < c.length; u++)
                    (!this.array || this.arrayOffset >= this.array.length) && (this.array = this.arrays.shift() || this.emptyArray, this.arrayOffset = 0), c[u] = this.array[this.arrayOffset++] || 0;
                  return !0;
                }
              }
            );
          }
          return await t.audioWorklet.addModule(
            `data:text/javascript,(${n.toString()})()`
          ), this.node = new AudioWorkletNode(t, "mstg-shim"), this.node.connect(s), i;
        },
        write(o) {
          const n = new Float32Array(
            o.numberOfFrames * o.numberOfChannels
          );
          o.copyTo(n, { planeIndex: 0 }), this.node.port.postMessage(n, [n.buffer]), o.close();
        }
      }), i;
    }
  }
}
function nr() {
  return self.MediaStreamTrackGenerator ? self.MediaStreamTrackGenerator : ir;
}
class or {
  constructor(e) {
    const t = e.track ?? e;
    t.kind == "video" ? this.readable = new ReadableStream({
      async start(s) {
        t.addEventListener(
          "ended",
          () => {
            try {
              s.close();
            } catch {
            }
          },
          { once: !0 }
        ), this.video = document.createElement("video"), this.video.setAttribute("playsinline", ""), this.video.srcObject = new MediaStream([t]), await Promise.all([
          this.video.play(),
          new Promise(
            (i) => this.video.onloadedmetadata = i
          )
        ]), this.track = t, this.canvas = new OffscreenCanvas(
          this.video.videoWidth,
          this.video.videoHeight
        ), this.ctx = this.canvas.getContext("2d", {
          desynchronized: !0
        }), this.t1 = performance.now();
      },
      async pull(s) {
        if (t.readyState == "ended") {
          try {
            s.close();
          } catch {
          }
          return;
        }
        const i = t.getSettings().frameRate || 30;
        for (; performance.now() - this.t1 < 1e3 / i; )
          if (await new Promise((o) => requestAnimationFrame(o)), t.readyState == "ended") {
            try {
              s.close();
            } catch {
            }
            return;
          }
        this.canvas.width = this.video.videoWidth, this.canvas.height = this.video.videoHeight, this.t1 = performance.now(), this.ctx.drawImage(this.video, 0, 0), s.enqueue(
          new VideoFrame(this.canvas, {
            timestamp: this.t1
          })
        );
      }
    }) : t.kind == "audio" && (this.readable = new ReadableStream({
      async start(s) {
        t.addEventListener(
          "ended",
          () => {
            try {
              s.close();
            } catch {
            }
          },
          { once: !0 }
        ), this.ac = new AudioContext(), this.arrays = [];
        function i() {
          registerProcessor(
            "mstp-shim",
            class extends AudioWorkletProcessor {
              process(n) {
                return this.port.postMessage(n), !0;
              }
            }
          );
        }
        await this.ac.audioWorklet.addModule(
          `data:text/javascript,(${i.toString()})()`
        ), this.node = new AudioWorkletNode(this.ac, "mstp-shim"), this.ac.createMediaStreamSource(new MediaStream([t])).connect(this.node), this.node.port.addEventListener(
          "message",
          ({ data: o }) => o[0][0] && this.arrays.push(o)
        );
      },
      async pull(s) {
        if (t.readyState == "ended") {
          try {
            s.close();
          } catch {
          }
          return;
        }
        for (; !this.arrays.length; )
          if (await new Promise(
            (n) => this.node.port.onmessage = n
          ), t.readyState == "ended") {
            try {
              s.close();
            } catch {
            }
            return;
          }
        const [i] = this.arrays.shift(), o = new Float32Array(
          i.reduce((n, a) => n + a.length, 0)
        );
        i.reduce(
          (n, a) => (o.set(a, n), n + a.length),
          0
        ), s.enqueue(
          new AudioData({
            format: "f32-planar",
            sampleRate: this.ac.sampleRate,
            numberOfFrames: i[0].length,
            numberOfChannels: i.length,
            timestamp: this.ac.currentTime * 1e6 | 0,
            data: o,
            transfer: [o.buffer]
          })
        );
      }
    }));
  }
}
function ar() {
  return self.MediaStreamTrackProcessor ? self.MediaStreamTrackProcessor : or;
}
class lr {
  constructor() {
    this.processor_ = null, this.generator_ = null;
  }
  init(e) {
    return new Promise((t, s) => {
      try {
        const i = ar();
        this.processor_ = new i(e);
      } catch (i) {
        console.log(
          `[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${i}`
        ), s(i);
      }
      try {
        const i = nr();
        e.kind === "audio" ? this.generator_ = new i({
          kind: "audio"
        }) : e.kind === "video" ? this.generator_ = new i({
          kind: "video"
        }) : s("kind not supported");
      } catch (i) {
        console.log(
          `[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${i}`
        ), s(i);
      }
      t();
    });
  }
  getReadable() {
    return this.processor_.readable;
  }
  getWriteable() {
    return this.generator_.writable;
  }
  getProccesorTrack() {
    return this.generator_;
  }
}
class hr {
  /**
   * - When running insertable streams on the main `MediaProcessorInterface` should be instance of `MediaProcessor` class.
   * - When running insertable streams on WebWorker `MediaProcessorInterface` should be instance of bridge calss created by the user. Example can be found [here](/docs/intro.md#using-the-transformer-on-webworker)
   * @param vonageMediaProcessor - MediaProcessorInterface.
   */
  constructor(e) {
    this.mediaProcessor_ = e;
  }
  /**
   * Sets the media stream track instance to be processed.
   *
   * @param track MediaStreamTrack (audio or video) to be processed.
   *
   * @returns New track to be used.
   */
  async setTrack(e) {
    if (!(this.mediaProcessor_ instanceof sr) && await Xe()) {
      if (e.kind === "audio")
        throw Error("Cannot process audio tracks inside a web worker when passing a track to transform");
      const t = rr(e);
      return await this.mediaProcessor_.transform(t);
    }
    if (Je()) {
      const t = new lr();
      return await t.init(e), await this.mediaProcessor_.transform(
        t.getReadable(),
        t.getWriteable()
      ), t.getProccesorTrack();
    }
    throw Error("MediaStreamTrack API for Insertable Streams of Media is not supported");
  }
  /**
   * Stops the media processing being performed.
   */
  destroy() {
    return new Promise((e, t) => {
      this.mediaProcessor_ ? this.mediaProcessor_.destroy().then(() => {
        e();
      }).catch((s) => {
        t(s);
      }) : t("no processor");
    });
  }
}
export {
  Zt as ErrorFunction,
  sr as MediaProcessor,
  hr as MediaProcessorConnector,
  Te as PipelineInfoData,
  St as VonageSourceType,
  Xt as WarningType,
  me as getVonageMetadata,
  cr as isSupported,
  fr as setVonageMetadata
};
